import { CompositeLayer, MVTLayer } from "deck.gl";
import { generateUrlGeoserverVector, hideLoading, showLoading } from "../core/utils";
import { _TerrainExtension as TerrainExtension, DataFilterExtension } from "@deck.gl/extensions";


export class BuildingSubsidence extends CompositeLayer {
    name = "xxx";
    componentName = "xxx";
    workspace = "";
    layerName = "";
    is3D = false;
    opacity = 100

    constructor(workspace, layerName, is3D, opacity) {
        super();

        this.workspace = workspace;
        this.layerName = layerName;
        this.is3D = is3D;
        this.opacity = opacity
    }

    shouldUpdateState({ changeFlags }) {
        return changeFlags.somethingChanged;
    }

    renderLayers() {
        const { zoom } = this.context.viewport;
        const dataSource = generateUrlGeoserverVector(this.workspace, this.layerName)

        return [
            // new MVTLayer({
            //     id: 'BuildingSubsidence1',
            //     data: dataSource,
            //     onTileLoad: showLoading,
            //     onViewportLoad: hideLoading,
            //     opacity: 0.8,
            //     stroked: true,
            //     filled: true,
            //     // extruded: this.is3D,
            //     // wireframe: false,
            //     getLineColor: [0, 0, 0, 150],
            //     // getLineColor: f => {
            //     //     console.log(f)
            //     //     return [0, 0, 0, 150]
            //     // },
            //     getFillColor: f => {
            //         const v = f.properties.inspection_priority_score
            //
            //
            //         if (v <= 0.33) {
            //             return [0, 128, 0]
            //         }
            //         if (v <= 0.66) {
            //             return [255, 255, 0]
            //         }
            //
            //         return [255, 0, 0]
            //     },
            //     getLineWidth: 1.0,
            //     lineWidthMinPixels: 1.0,
            //     pickable: true,
            //     // getElevation: this.is3D ? d => d.properties.height : 0,
            //     getElevation: this.is3D ? 10 : 0,
            //     terrainDrawMode: this.is3D ? 'offset' : '',
            //     extruded: true,
            //
            //     getFilterValue: d => d.properties.inspection_priority_score,
            //     filterRange: [[0.33, 10]],
            //     extensions: this.is3D
            //         ? [new DataFilterExtension({filterSize: 1}), new TerrainExtension()]
            //         : [new DataFilterExtension({filterSize: 1})],
            //
            //     visible: zoom < 10
            // }),
            new MVTLayer({
                id: 'BuildingSubsidence2',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                opacity: this.opacity / 100,
                stroked: true,
                filled: true,
                // extruded: this.is3D,
                // wireframe: false,
                getLineColor: [0, 0, 0, 150],
                // getLineColor: f => {
                //     console.log(f)
                //     return [0, 0, 0, 150]
                // },
                getFillColor: f => {
                    const v = f.properties.inspection_priority_score

                    if (v <= 0.33) {
                        return [0, 128, 0]
                    }
                    if (v <= 0.66) {
                        return [255, 255, 0]
                    }

                    return [255, 0, 0]
                },
                getLineWidth: 1.0,
                lineWidthMinPixels: 1.0,
                pickable: true,
                getElevation: this.is3D ? d => d.properties.height : 0,
                terrainDrawMode: this.is3D ? 'offset' : '',
                extensions: this.is3D ? [new TerrainExtension()] : [],
                extruded: this.is3D,
                dataComparator: (a, b) => false

                // visible: zoom >= 7.5
            }),
        ];
    }
}
